import { Box, Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const AboutPage = () => {
  const { state } = useLocation();
  const { data } = state || {};
  const history = useHistory();
  const textColor = useColorModeValue('navy.700', 'white');

  return data?.name ? (
    <Box
      mt={32}
      maxW='5xl'>
      <Flex
        direction='column'
        gap={12}>
        <Text
          color={textColor}
          as='u'
          fontSize={{
            base: 'xl',
            md: '2xl',
            lg: '2xl',
            xl: '2xl',
            '2xl': '2xl',
            '3xl': '2xl',
          }}
          fontWeight='bold'>
          {data?.name}
        </Text>
        <Flex
          direction='column'
          gap={2}>
          {data?.paragraphs.map((paragraph) => (
            <Text
              fontSize='lg'
              key={paragraph}>
              {paragraph}
            </Text>
          ))}
        </Flex>
        <Flex>
          <Button
            colorScheme='blue'
            onClick={(e) => {
              history.push(data.pageAddress);
            }}>
            {data?.buttonLabel}
          </Button>
        </Flex>
      </Flex>
    </Box>
  ) : (
    <>{history.push('/admin/default')}</>
  );
};

export default AboutPage;
